import {
  COMMONS_ENVIRONMENT,
  ConfigLoader,
  DefaultConfigLoader,
  EnvironmentConfigLoader,
  OAuthInterceptor,
  ServerSettingsService,
  SettingsService,
  W3hostnameInterceptor,
} from '@infodata-group/inf-commons';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const commonsProviders = [
  { provide: COMMONS_ENVIRONMENT, useValue: environment },
  { provide: ConfigLoader, useClass: EnvironmentConfigLoader },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: W3hostnameInterceptor,
    multi: true,
  },
  { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
  { provide: SettingsService, useClass: ServerSettingsService },
];
